enum PaginationDirectionEnum {
    DECR = "decr",
    INCR = "incr",
    START = "start",
    END = "end",
}

export default PaginationDirectionEnum;
